var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Header"},[_c('MenuCommon',{staticClass:"header-menu",attrs:{"type":"PC"}}),_c('MenuMobile',{staticClass:"header-menu-more"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }